import { TimeSlot } from "types/time-slot";

/**
 * Compares wait list time slots by rule and start time.
 * @param a - First time slot to compare.
 * @param b - Second time slot to compare.
 * @returns True when both slots represent the same wait list entry.
 * @example
 * isSameWaitListSlot(slotA, slotB);
 */
function isSameWaitListSlot(a: TimeSlot, b: TimeSlot) {
    return a.ruleId === b.ruleId && a.start.isSame(b.start);
}

export { isSameWaitListSlot };
